"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateContentWithoutHeading = exports.generateContentWithHeading = void 0;
var DEFAULT = {
    heading: 'Your heading text goes here',
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's \n      standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
};
function generateContentWithHeading(_a) {
    var _b = _a === void 0 ? DEFAULT : _a, heading = _b.heading, text = _b.text;
    return "<div class=\"eg-content-editor\" data-type=\"textEditorOneColumn\" style=\"width: 100%;\">\n              <div class=\"column\" style=\"display: inline-block; width: 100%; vertical-align: top;\">\n                <h2>" + heading + "</h2>\n                <p>" + text + "</p>\n              </div>\n          </div>";
}
exports.generateContentWithHeading = generateContentWithHeading;
function generateContentWithoutHeading(defaultText) {
    if (defaultText === void 0) { defaultText = DEFAULT.text; }
    return "<div class=\"eg-content-editor\" data-type=\"textEditorWithoutHeading\" style=\"width: 100%;\">\n              <div class=\"column\" style=\"display: inline-block; width: 100%; vertical-align: top;\">\n                <p>" + defaultText + "</p>\n              </div>\n          </div>";
}
exports.generateContentWithoutHeading = generateContentWithoutHeading;
